import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from 'uuid';
import {
  useAddVideoMutation,
  useEditVideoMutation,
  useGetVideoQuery,
} from "../../../features/videos/videosApi";
import { endEditing } from "../../../features/videos/videosSlice";

const VideoModal = ({ open, control }) => {
  const dispatch = useDispatch();

  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [views, setViews] = useState("");
  const [duration, setDuration] = useState("");
  const [description, setDescription] = useState("");

  // getting the video id for populating form data while editing
  const { videoId, editMode } = useSelector((state) => state.video.editing);

  const { data: video, isLoading, isError, refetch } = useGetVideoQuery(videoId);
  const [addVideo, { isSuccess:isCreateSuccess}] = useAddVideoMutation();
  const [editVideo, {isSuccess: isEditSuccess}] = useEditVideoMutation();

  useEffect(() => {
    if (video?.id) {
      const {
        title: initialTitle,
        url: initialUrl,
        views: initialViews,
        duration: initialDuration,
        description: initialDescription,
      } = video;

      setTitle(initialTitle);
      setUrl(initialUrl);
      setViews(initialViews);
      setDuration(initialDuration);
      setDescription(initialDescription);
    }
  }, [videoId, video]);

  useEffect(() => {
    if (isCreateSuccess || isEditSuccess) {
      refetch();
    }
  }, [isCreateSuccess, isEditSuccess]);

  const formReset = () => {
    setTitle("");
    setUrl("");
    setViews("");
    setDuration("");
    setDescription("");
  }

  const handleCreate = (e) => {
    e.preventDefault();

    const data = {
      id: uuid(),
      title,
      url,
      duration,
      views,
      description,
      createdAt: new Date().toISOString(),
    };

    addVideo(data);
    closeModal()
  };

  const handleEdit = (e) => {
    e.preventDefault();

    const data = {
      title,
      url,
      duration,
      views,
      description,
      createdAt: video.createdAt
    };

    editVideo({data, videoId});
    closeModal()
  };

  const closeModal = () =>  {
    dispatch(endEditing());
    formReset();
    control();
  }

  return (
    open && (
      <main className="bg-secondary flex flex-col mx-8 p-8 form-modal">
        <h1 className="mb-10 text-center lws-section-title mt-8 text-2xl">
         {editMode ? "Edit video" : "Add New Video Lesson"}
        </h1>

        <div className="max-w-md mx-auto mt-8">
          <form className="flex flex-col space-y-6" onSubmit={editMode ? handleEdit : handleCreate}>
            <div className="fieldContainer">
              <label>Title</label>
              <div className="flex border border-cyan rounded-md shadow-sm">
                <input
                  type="text"
                  required
                  className="bg-secondary w-full h-8 py-2 px-3 rounded-md form-input"
                  placeholder="Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
            </div>
            <div className="fieldContainer">
              <label>Url</label>
              <div className="flex border border-cyan rounded-md shadow-sm">
                <input
                  type="text"
                  required
                  className="bg-secondary w-full h-8 py-2 px-3 rounded-md form-input"
                  placeholder="Paste the url here"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                />
              </div>
            </div>

            <div className="fieldContainer">
              <label>Views</label>
              <div className="flex border border-cyan rounded-md shadow-sm">
                <input
                  type="text"
                  required
                  className="bg-secondary w-full h-8 py-2 px-3 rounded-md form-input"
                  placeholder="total views"
                  value={views}
                  onChange={(e) => setViews(e.target.value)}
                />
              </div>
            </div>
            <div className="fieldContainer">
              <label>Duration</label>
              <div className="flex border border-cyan rounded-md shadow-sm">
                <input
                  type="text"
                  required
                  className="bg-secondary w-full h-8 py-2 px-3 rounded-md form-input"
                  placeholder="duration"
                  value={duration}
                  onChange={(e) => setDuration(e.target.value)}
                />
              </div>
            </div>
            <div className="fieldContainer">
              <label>Description</label>
              <div className="flex border border-cyan rounded-md shadow-sm">
                <textarea
                  required
                  className="bg-secondary w-full py-2 px-3 rounded-md form-input"
                  placeholder="Write description here"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>

            <div className="flex justify-end space-x-4">
              <button
                onClick={closeModal}
                className="cursor-pointer btn bg-red-600 w-fit absolute"
                style={{ marginRight: "10px" }}
              >
                Cancel
              </button>
              <button
                type="submit"
                id="lws-submit"
                className="cursor-pointer btn w-fit"
              >
                {editMode ? "Edit" : "Add"}
              </button>
            </div>
          </form>
        </div>
      </main>
    )
  );
};

export default VideoModal;
